import Vue from 'vue';
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

import sc from "./language/sc.js"
import en from "./language/en.js"
import tc from "./language/tc.js"

const i18n = new VueI18n({
    // 设置默认语言
    locale: 'tc', // 语言标识
    // 添加多语言（每一个语言标示对应一个语言文件）
    messages: {
        sc,
        en,
        tc
    }
})

export default i18n